import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import CashInOutServices from "./CashInOutServices";

const initialState = {
  expenses: [],
  cashes: [],
  expenseOut: null,
  cashInByDate: [],
  expenseOutByDate: [],
  cashIn: null,
  isError: false,
  isSuccess: false,
  isSuccessCash: false,
  isSuccessExpense: false,
  isLoading: false,
  message: "",
};
export const createExpenseOut = createAsyncThunk(
  "cashInOut/createExpenseOut",
  async (expenseData, thunkAPI) => {
    try {
      return await CashInOutServices.createExpenseOut(expenseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExpenseOuts = createAsyncThunk(
  "cashInOut/getExpenseOuts",
  async (_, thunkAPI) => {
    try {
      return await CashInOutServices.getExpenseOuts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateExpenseEntry = createAsyncThunk(
  "cashInOut/updateExpenseEntry",
  async (expenseData, thunkAPI) => {
    try {
      return await CashInOutServices.updateExpenseEntry(expenseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteExpense = createAsyncThunk(
  "cashInOut/deleteExpense",
  async (id, thunkAPI) => {
    try {
      return await CashInOutServices.deleteExpense(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createCashIn = createAsyncThunk(
  "cashInOut/createCashIn",
  async (cashInData, thunkAPI) => {
    try {
      return await CashInOutServices.createCashIn(cashInData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCashIn = createAsyncThunk(
  "cashInOut/getCashIn",
  async (_, thunkAPI) => {
    try {
      return await CashInOutServices.getCashIn();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCashEntry = createAsyncThunk(
  "cashInOut/updateCashEntry",
  async (cashData, thunkAPI) => {
    try {
      return await CashInOutServices.updateCashEntry(cashData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteCash = createAsyncThunk(
  "cashInOut/deleteCash",
  async (id, thunkAPI) => {
    try {
      return await CashInOutServices.deleteCash(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExpenseOutForRrport = createAsyncThunk(
  "cashInOut/getExpenseOutForRrport",
  async (orderData, thunkAPI) => {
    try {
      const response = await CashInOutServices.getExpenseOutForRrport(
        orderData
      );
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCashInForRrport = createAsyncThunk(
  "cashInOut/getCashInForRrport",
  async (orderData, thunkAPI) => {
    try {
      const response = await CashInOutServices.getCashInForRrport(orderData);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const cashInOutSlice = createSlice({
  name: "cashInOut",
  initialState,
  reducers: {
    RESET_CASHINOUT(state) {
      state.isError = false;
      state.isSuccessCash = false;
      state.isSuccessExpense = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(createExpenseOut.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createExpenseOut.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessExpense = true;
        state.expenseOut = action.payload.data;
        // console.log(action.payload);
      })

      .addCase(createExpenseOut.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getExpenseOuts.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getExpenseOuts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.expenses = action.payload.data;
      })

      .addCase(getExpenseOuts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        // toast.error(action.payload);
      })

      .addCase(updateExpenseEntry.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateExpenseEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessExpense = true;
        state.expenses = action.payload.data;
        // console.log(action.payload);
      })

      .addCase(updateExpenseEntry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deleteExpense.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessExpense = true;
        state.message = action.payload;
        toast.success(action.payload);
      })

      .addCase(deleteExpense.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(createCashIn.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createCashIn.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCash = true;
        state.cashIn = action.payload.data;
        // console.log(action.payload);
      })

      .addCase(createCashIn.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getCashIn.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getCashIn.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.cashes = action.payload.data;
        // console.log(action.payload);
      })

      .addCase(getCashIn.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        // toast.error(action.payload);
      })

      .addCase(updateCashEntry.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateCashEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCash = true;
        state.cashIn = action.payload.data;
        // console.log(action.payload);
      })

      .addCase(updateCashEntry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })
      .addCase(deleteCash.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteCash.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCash = true;
        state.message = action.payload;
        toast.success(action.payload);
      })

      .addCase(deleteCash.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })
      .addCase(getCashInForRrport.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getCashInForRrport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.cashInByDate = action.payload;
      })

      .addCase(getCashInForRrport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.cashInByDate = null;
        toast.error(action.payload);
      })

      .addCase(getExpenseOutForRrport.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getExpenseOutForRrport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.expenseOutByDate = action.payload;
      })

      .addCase(getExpenseOutForRrport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.expenseOutByDate = null;
        toast.error(action.payload);
      });
  },
});

export const { RESET_CASHINOUT } = cashInOutSlice.actions;
export const selectSuccessExpense = (state) => state.cashInOut.isSuccessExpense;
export const selectExpenses = (state) => state.cashInOut.expenses;
export const selectSuccessCash = (state) => state.cashInOut.isSuccessCash;
export const selectCashes = (state) => state.cashInOut.cashes;
export const selectCashInByDate = (state) => state.cashInOut?.cashInByDate;
export const selectExpenseOutByDate = (state) =>
  state.cashInOut?.expenseOutByDate;

export default cashInOutSlice.reducer;
